/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetStorefrontScripts200ResponseInnerScripts
 */
export interface GetStorefrontScripts200ResponseInnerScripts {
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontScripts200ResponseInnerScripts
     */
    pageviewHeaderScripts?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontScripts200ResponseInnerScripts
     */
    pageviewBodyScripts?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontScripts200ResponseInnerScripts
     */
    conversionScripts?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontScripts200ResponseInnerScripts
     */
    googleAnalyticsId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontScripts200ResponseInnerScripts
     */
    facebookAnalyticsId?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontScripts200ResponseInnerScripts
     */
    metaConversionApiToken?: string;
    /**
     * 
     * @type {string}
     * @memberof GetStorefrontScripts200ResponseInnerScripts
     */
    googleTagManagerId?: string;
}

/**
 * Check if a given object implements the GetStorefrontScripts200ResponseInnerScripts interface.
 */
export function instanceOfGetStorefrontScripts200ResponseInnerScripts(value: object): value is GetStorefrontScripts200ResponseInnerScripts {
    return true;
}

export function GetStorefrontScripts200ResponseInnerScriptsFromJSON(json: any): GetStorefrontScripts200ResponseInnerScripts {
    return GetStorefrontScripts200ResponseInnerScriptsFromJSONTyped(json, false);
}

export function GetStorefrontScripts200ResponseInnerScriptsFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStorefrontScripts200ResponseInnerScripts {
    if (json == null) {
        return json;
    }
    return {
        
        'pageviewHeaderScripts': json['pageviewHeaderScripts'] == null ? undefined : json['pageviewHeaderScripts'],
        'pageviewBodyScripts': json['pageviewBodyScripts'] == null ? undefined : json['pageviewBodyScripts'],
        'conversionScripts': json['conversionScripts'] == null ? undefined : json['conversionScripts'],
        'googleAnalyticsId': json['googleAnalyticsId'] == null ? undefined : json['googleAnalyticsId'],
        'facebookAnalyticsId': json['facebookAnalyticsId'] == null ? undefined : json['facebookAnalyticsId'],
        'metaConversionApiToken': json['metaConversionApiToken'] == null ? undefined : json['metaConversionApiToken'],
        'googleTagManagerId': json['googleTagManagerId'] == null ? undefined : json['googleTagManagerId'],
    };
}

export function GetStorefrontScripts200ResponseInnerScriptsToJSON(json: any): GetStorefrontScripts200ResponseInnerScripts {
    return GetStorefrontScripts200ResponseInnerScriptsToJSONTyped(json, false);
}

export function GetStorefrontScripts200ResponseInnerScriptsToJSONTyped(value?: GetStorefrontScripts200ResponseInnerScripts | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pageviewHeaderScripts': value['pageviewHeaderScripts'],
        'pageviewBodyScripts': value['pageviewBodyScripts'],
        'conversionScripts': value['conversionScripts'],
        'googleAnalyticsId': value['googleAnalyticsId'],
        'facebookAnalyticsId': value['facebookAnalyticsId'],
        'metaConversionApiToken': value['metaConversionApiToken'],
        'googleTagManagerId': value['googleTagManagerId'],
    };
}

